<style scoped>

</style>
<template>
    <div class="contractBox">
        <BetweenList v-if="betweenListShow" @checkViewShow='checkViewShow' @getId='getId' :now='now'></BetweenList>
        <Village v-if="billageShow" @checkViewShow='checkViewShow' :nowId='nowId'></Village>
    </div>
</template>
<script>
import BetweenList from '../components/BetweenList'
import Village from '../components/VillageInfo'
export default {
    components:{
        Village,
        BetweenList,
    },
    props:['now'],
    data(){
        return {
            betweenListShow: true,
            billageShow: false,
            nowId:''
        }
    },
    computed: {
        
    },
    mounted: async function(){
        
    },
    methods: {
        goBack(){
            this.betweenListShow = true;
            this.billageShow = false;
        },
        getId(id){
            this.nowId = id
        },
        checkViewShow(){
            if(this.betweenListShow){
                this.betweenListShow = false;
                this.billageShow = true
            }else{
                this.betweenListShow = true;
                this.billageShow =false
            }
            
        }
    }
}
</script>